import React from "react";

const StyledSmText = ({ children, font }) => {
  return (
    <p className={`text-sm font-star-jedi lowercase ${font}`}>{children}</p>
  );
};

export default StyledSmText;
